import { render, staticRenderFns } from "./ReqKP.vue?vue&type=template&id=dc694cf6&"
import script from "./ReqKP.vue?vue&type=script&lang=js&"
export * from "./ReqKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports